import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, Icon } from "@app/components";
import { SuccessContainer, ProfileSuccessText } from "../profileEditSuccess/success-components";
import { SuccessText } from "@app/modules/signUp/sign-up.component";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "../success-modal/success-modal-components";
import { AuthContext } from "@app/providers";
import { logoutUser } from "@app/services";
import { useLocation } from "@app/utils";
import { getDefaultUrl } from "../../routes/route-helpers";
import { ContentHolder, FlexWrapper, Layout, PopupDialog } from "../commonStyles/common-components";
import { LargeLeaf, SmallLeaf } from "@app/assets";

type Props = {
  pathData?: any;
  pathData1?:any
}



export default function UserConfirmation(pathData: Props,pathData1:Props) {
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const [userDetails, updateUserDetails] = useState<any>({});
  const { navigate } = useLocation();
  const defaultUrl: string = getDefaultUrl(userInfo && userInfo.userJson);
  const [userType, showUserType] = useState(userInfo.userJson.userType)
  const [requestedUser, showRequestedUser] = useState(pathData.pathData[1])

  useEffect(() => {
    if (userInfo && userInfo.sessionToken) {
      const user = userInfo.userJson;
      updateUserDetails(user);
    }
  }, [userInfo])

  function logout() {
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      sessionToken: userInfo && userInfo.sessionToken,
    });
    logoutUser(params)
      .then((res: any) => {
        if (res._responseStatus === 1) {
          localStorage.clear();
          setUserInfo(null);
          navigate("/sign-in/student");
          if(pathData.pathData1[1]){
            navigate('/sign-up')
          }

        } else if (res.msgCode === "SSN_002") {
          localStorage.clear();
          setUserInfo(null);
          navigate("/sign-in");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  function Redirection() {
    localStorage.clear()
    logout()
    
  }
  function onClose() {
    navigate(defaultUrl);
   
  }
  return (
    // <PopUpWrapper>
    //     <PopUpContainer>

    //         <PopUpTitle>You have already Signed-in to the application with <span style={{textTransform:"capitalize"}}> {userType}</span></PopUpTitle>
    //         <PopUpSubTitle>Are you sure you want to Sign-out from your account and continue with <span style={{textTransform:"capitalize"}}> {requestedUser}</span> Sign-in ? </PopUpSubTitle>

    //         <FlexWrapper className="mt-3">
    //             <Button
    //                 variant="newsecondary"
    //                 type="button"
    //                 onClick={Redirection}
    //                 customClass="mr-2"
    //             >
    //                 Yes
    //             </Button>
    //             <Button
    //                 variant="text"
    //                 type="button"
    //                 onClick={onClose}
    //             >
    //                 No
    //             </Button>
    //         </FlexWrapper>
    //     </PopUpContainer>
    // </PopUpWrapper>


    <Layout className="alt">
      <ContentHolder className="aligned-center">
        <PopupDialog className="w-700 m-0">
          <img alt="" className="top-left-image" src={SmallLeaf} />
          <PopUpSubTitle className="popupsubtitle-color">You have already signed-in to the application with <span style={{ textTransform: "capitalize" }}> {userType}</span> account. </PopUpSubTitle>
          <PopUpText>Are you sure you want to sign-out from your account <br /> and continue with <span style={{ textTransform: "capitalize" }}> 
          {requestedUser || pathData.pathData1[1]}</span> {pathData.pathData1[1] ? 'Sign-up?': 'Sign-in?'} </PopUpText>

          <FlexWrapper className="justify-center mt-3">
            <Button
              variant="newsecondary"
              type="button"
              onClick={Redirection}
              customClass="mr-2"
            >
              Yes
                    </Button>
            <Button
              variant="text"
              type="button"
              onClick={onClose}
            >
              No
                    </Button>
          </FlexWrapper>
        </PopupDialog>
      </ContentHolder>
      <img alt="" className="bottom-right-image" src={LargeLeaf} />
    </Layout>


    //   <Dialog noTitle={true} onClose={onClose}>
    //       <SuccessContainer>
    //         {/* <Icon name="failIcon" /> */}
    //         <ProfileSuccessText className="failure">You have already login into the application with another user type.</ProfileSuccessText>
    //         <SuccessText>Do you want to change the user type now or continue with existing user type.?</SuccessText>

    //         <div style={{display:"flex"}}>
    //         <Button
    //           variant="newsecondary"
    //           type="button"
    //           onClick={onClose}
    //           style={{marginRight:"20px"}}
    //         >
    //           Yes
    //           </Button>
    //           <Button
    //           variant="newsecondary"
    //           type="button"
    //           onClick={onClose}
    //         >
    //           No
    //           </Button>
    //           </div>

    //       </SuccessContainer>
    //     </Dialog>  


  );
}


